export default {
  getPickup: state => state.barColor,
  getStores: state => state.stores,
  getMapIcons: state => state.mapIcons,
  getSelectedStore: state => state.selectedStore,
  getSelectedLocation: state => state.selectedLocation,
  getAddresses: state => state.addresses
};
